module.exports = __webpack_public_path__ + "media/images/about-us-img-01-bfe80c771c4d04d341485c90257a2d7e.jpg";